import React from "react";

import BaseApp from "@apps/base/BaseApp";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";

import {setConsumerHeader} from "@globals/utils/setConsumerHeader";

import DishApp from "./DishApp";

setConsumerHeader();

const root = createRoot(document.getElementById("root")!);

root.render(
  <BaseApp showLoginLink={true}>
    <BrowserRouter basename="/dish/">
      <DishApp />
    </BrowserRouter>
  </BaseApp>
);
